var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRejected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM14.43 14.43C14.2884 14.5716 14.0821 14.607 13.9081 14.5362C14.0821 14.607 14.2884 14.5716 14.43 14.43C14.5792 14.2797 14.6096 14.0557 14.5213 13.876C14.6096 14.0557 14.5792 14.2797 14.43 14.43ZM12 12.6815L12 12.6815L10.2515 14.43C10.1106 14.5708 9.90569 14.6066 9.73229 14.5373C9.90568 14.6066 10.1106 14.5708 10.2515 14.43L12 12.6815ZM14.43 10.2515C14.5952 10.0863 14.6158 9.83297 14.4919 9.64575C14.6158 9.83296 14.5952 10.0863 14.43 10.2515L12.6815 12L12.6815 12L14.43 10.2515ZM13.2874 12L14.7329 10.5544C15.089 10.1983 15.089 9.62315 14.7329 9.26707C14.3768 8.91098 13.8017 8.91098 13.4456 9.26707L12 10.7126L10.5544 9.26707C10.1983 8.91098 9.62315 8.91098 9.26707 9.26707C8.91098 9.62315 8.91098 10.1983 9.26707 10.5544L10.7126 12L9.26707 13.4456C8.91098 13.8017 8.91098 14.3768 9.26707 14.7329C9.62315 15.089 10.1983 15.089 10.5544 14.7329L12 13.2874L13.4456 14.7329C13.8017 15.089 14.3768 15.089 14.7329 14.7329L14.734 14.7319C15.0867 14.3766 15.0883 13.8009 14.7329 13.4456L13.2874 12Z",
    fill: "#F42E33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejected);
export default __webpack_public_path__ + "static/media/rejected.4a66acf19961918dca9773648d05bcbe.svg";
export { ForwardRef as ReactComponent };